import { jsx as _jsx } from "react/jsx-runtime";
import { StyledHeader } from "./styled";
export var Header = function () {
    return _jsx(StyledHeader, { children: _jsx("h2", { children: "eNPS Survey" }) });
};
